import { useNavigate } from 'react-router-dom';

export default function Terms() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#f5f1e8]">
      {/* Header */}
      <header className="bg-white/80 backdrop-blur-sm border-b border-[#e8dfd0] sticky top-0 z-40">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <h1 
            onClick={() => navigate('/')}
            className="text-2xl font-light cursor-pointer hover:text-[#6b5d4f] transition-colors duration-200" 
            style={{ fontFamily: 'Georgia, serif', color: '#4a3f33' }}
          >
            게임기획자 해든의 낙서
          </h1>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-16">
        <div className="bg-white/60 border border-[#e8dfd0] rounded-lg p-8 md:p-12">
          <h1 className="text-3xl font-light text-[#4a3f33] mb-8" style={{ fontFamily: 'Georgia, serif' }}>
            이용약관
          </h1>

          <div className="space-y-8 text-[#4a3f33]">
            <section>
              <h2 className="text-xl font-normal text-[#4a3f33] mb-4" style={{ fontFamily: 'Georgia, serif' }}>
                제1조 (목적)
              </h2>
              <div className="text-sm text-[#6b5d4f] leading-relaxed">
                <p>본 약관은 게임기획자 해든의 낙서(이하 "본 사이트")가 제공하는 모든 서비스(이하 "서비스")의 이용 조건 및 절차, 이용자와 본 사이트의 권리, 의무, 책임사항과 기타 필요한 사항을 규정함을 목적으로 합니다.</p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-normal text-[#4a3f33] mb-4" style={{ fontFamily: 'Georgia, serif' }}>
                제2조 (용어의 정의)
              </h2>
              <div className="text-sm text-[#6b5d4f] leading-relaxed space-y-2">
                <p>본 약관에서 사용하는 용어의 정의는 다음과 같습니다:</p>
                <ul className="list-decimal list-inside pl-4 space-y-2 mt-2">
                  <li><span className="font-medium text-[#4a3f33]">"서비스"</span>란 본 사이트가 제공하는 게임 기획 인사이트, 분석 리포트, 아이디어 아카이빙 등 모든 콘텐츠 및 관련 서비스를 의미합니다.</li>
                  <li><span className="font-medium text-[#4a3f33]">"이용자"</span>란 본 사이트에 접속하여 본 약관에 따라 서비스를 이용하는 모든 방문자를 말합니다.</li>
                  <li><span className="font-medium text-[#4a3f33]">"콘텐츠"</span>란 본 사이트에 게시된 글, 이미지, 동영상, 링크 등 모든 정보와 자료를 의미합니다.</li>
                  <li><span className="font-medium text-[#4a3f33]">"프리미엄 콘텐츠"</span>란 유료 구독을 통해서만 열람 가능한 특별 콘텐츠를 의미합니다.</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-normal text-[#4a3f33] mb-4" style={{ fontFamily: 'Georgia, serif' }}>
                제3조 (약관의 효력 및 변경)
              </h2>
              <div className="text-sm text-[#6b5d4f] leading-relaxed space-y-2">
                <p>① 본 약관은 서비스를 이용하고자 하는 모든 이용자에게 그 효력이 발생합니다.</p>
                <p>② 본 사이트는 필요한 경우 관련 법령을 위배하지 않는 범위에서 본 약관을 변경할 수 있으며, 약관이 변경되는 경우 지체 없이 사이트 내 공지사항을 통해 공지합니다.</p>
                <p>③ 이용자가 변경된 약관에 동의하지 않는 경우, 서비스 이용을 중단하고 탈퇴할 수 있습니다. 변경된 약관의 효력 발생일 이후에도 서비스를 계속 이용하는 경우 약관의 변경 사항에 동의한 것으로 간주됩니다.</p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-normal text-[#4a3f33] mb-4" style={{ fontFamily: 'Georgia, serif' }}>
                제4조 (서비스의 제공 및 변경)
              </h2>
              <div className="text-sm text-[#6b5d4f] leading-relaxed space-y-2">
                <p>① 본 사이트는 다음과 같은 서비스를 제공합니다:</p>
                <ul className="list-disc list-inside pl-4 space-y-1">
                  <li>게임 기획 인사이트 및 분석 콘텐츠</li>
                  <li>히트 게임 코어루프 분석</li>
                  <li>패스트 팔로워 전략 연구</li>
                  <li>게임 아이디어 아카이빙</li>
                  <li>프리미엄 히트 예측 리포트 (유료)</li>
                  <li>기타 게임 기획 관련 정보 제공</li>
                </ul>
                <p>② 본 사이트는 서비스의 내용을 변경하거나 추가할 수 있으며, 이 경우 변경 내용을 사이트에 공지합니다.</p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-normal text-[#4a3f33] mb-4" style={{ fontFamily: 'Georgia, serif' }}>
                제5조 (서비스의 중단)
              </h2>
              <div className="text-sm text-[#6b5d4f] leading-relaxed space-y-2">
                <p>① 본 사이트는 다음 각 호에 해당하는 경우 서비스 제공을 일시적으로 중단할 수 있습니다:</p>
                <ul className="list-decimal list-inside pl-4 space-y-1">
                  <li>시스템 정기점검, 서버의 증설 및 교체, 네트워크의 불안정 등의 시스템 운영상 필요한 경우</li>
                  <li>정전, 서비스 설비의 장애, 서비스 이용 폭주 등으로 정상적인 서비스 제공이 불가능한 경우</li>
                  <li>기타 천재지변, 국가비상사태 등 불가항력적 사유가 있는 경우</li>
                </ul>
                <p>② 본 사이트는 서비스 중단의 경우 사전에 공지하며, 부득이한 사유로 사전 공지가 불가능한 경우 사후에 공지합니다.</p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-normal text-[#4a3f33] mb-4" style={{ fontFamily: 'Georgia, serif' }}>
                제6조 (이용자의 의무)
              </h2>
              <div className="text-sm text-[#6b5d4f] leading-relaxed space-y-2">
                <p>① 이용자는 다음 행위를 하여서는 안 됩니다:</p>
                <ul className="list-decimal list-inside pl-4 space-y-1">
                  <li>타인의 정보 도용</li>
                  <li>본 사이트에 게시된 정보의 무단 변경, 삭제</li>
                  <li>본 사이트가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시</li>
                  <li>본 사이트 및 제3자의 저작권 등 지적재산권에 대한 침해</li>
                  <li>본 사이트 및 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
                  <li>외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 공개 또는 게시하는 행위</li>
                  <li>본 사이트의 콘텐츠를 무단으로 상업적 목적으로 사용하는 행위</li>
                </ul>
                <p>② 이용자는 관계 법령, 본 약관의 규정, 이용안내 및 서비스와 관련하여 공지한 주의사항 등을 준수하여야 합니다.</p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-normal text-[#4a3f33] mb-4" style={{ fontFamily: 'Georgia, serif' }}>
                제7조 (저작권의 귀속 및 이용 제한)
              </h2>
              <div className="text-sm text-[#6b5d4f] leading-relaxed space-y-2">
                <p>① 본 사이트가 작성한 저작물에 대한 저작권 및 기타 지적재산권은 본 사이트에 귀속됩니다.</p>
                <p>② 이용자는 본 사이트를 이용함으로써 얻은 정보 중 본 사이트에 지적재산권이 귀속된 정보를 본 사이트의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리 목적으로 이용하거나 제3자에게 이용하게 하여서는 안 됩니다.</p>
                <p>③ 본 사이트의 콘텐츠는 개인적, 비상업적 용도로만 열람 가능하며, 무단 복제 및 배포를 금지합니다.</p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-normal text-[#4a3f33] mb-4" style={{ fontFamily: 'Georgia, serif' }}>
                제8조 (면책 조항)
              </h2>
              <div className="text-sm text-[#6b5d4f] leading-relaxed space-y-2">
                <p>① 본 사이트는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.</p>
                <p>② 본 사이트는 이용자의 귀책사유로 인한 서비스 이용의 장애에 대하여 책임을 지지 않습니다.</p>
                <p>③ 본 사이트는 이용자가 서비스를 이용하여 기대하는 수익을 상실한 것에 대하여 책임을 지지 않으며, 그 밖에 서비스를 통하여 얻은 자료로 인한 손해에 관하여 책임을 지지 않습니다.</p>
                <p>④ 본 사이트에서 제공하는 정보는 참고용이며, 게임 개발 및 투자 결정에 대한 최종 책임은 이용자 본인에게 있습니다.</p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-normal text-[#4a3f33] mb-4" style={{ fontFamily: 'Georgia, serif' }}>
                제9조 (분쟁 해결)
              </h2>
              <div className="text-sm text-[#6b5d4f] leading-relaxed space-y-2">
                <p>① 본 사이트는 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여 피해보상처리기구를 설치·운영합니다.</p>
                <p>② 본 사이트와 이용자 간에 발생한 분쟁은 전자거래기본법 제28조 및 동 시행령 제15조에 의하여 설치된 전자거래분쟁조정위원회의 조정에 따를 수 있습니다.</p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-normal text-[#4a3f33] mb-4" style={{ fontFamily: 'Georgia, serif' }}>
                제10조 (재판권 및 준거법)
              </h2>
              <div className="text-sm text-[#6b5d4f] leading-relaxed">
                <p>본 약관과 관련하여 분쟁이 발생한 경우, 대한민국 법을 준거법으로 하며, 관할 법원은 민사소송법에 따릅니다.</p>
              </div>
            </section>

            <section className="pt-6 border-t border-[#e8dfd0]">
              <div className="text-sm text-[#6b5d4f] leading-relaxed">
                <p className="font-medium text-[#4a3f33]">부칙</p>
                <p className="mt-2">본 약관은 2026년 1월 1일부터 시행됩니다.</p>
              </div>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#e8dcc8] py-8 px-6 mt-16">
        <div className="max-w-6xl mx-auto text-center">
          <p className="text-xs text-[#7a6d5f]">© 2026 게임기획자 해든의 낙서</p>
        </div>
      </footer>
    </div>
  );
}
